import React from 'react';
import { Toggle } from '@cimpress/react-components';
import { css } from 'emotion';
import { LOADING } from '../../constants/entityStatus';
import { useTranslation } from 'react-i18next';

const divStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '25px'
});

export function AppSettingsConfig({
  showTerminated,
  enableShippingCosts,
  toggleTerminated,
  toggleEnableShippingCosts,
  isFetchingUserConfigurations
}) {
  if (isFetchingUserConfigurations) {
    return LOADING;
  }

  const { t } = useTranslation();

  return (
    <div>
      <div className={divStyle}>
        <span>
          <b>{t('settings:features.terminatedContracts.label')}</b>
        </span>
        <Toggle
          on={showTerminated}
          onText={t('common:commonWords.onText')}
          offText={t('common:commonWords.offText')}
          onClick={toggleTerminated}
        />
      </div>
      <div className={divStyle}>
        <span>
          <b>{t('settings:features.shippingContracts.label')}</b>
        </span>
        <Toggle
          on={enableShippingCosts}
          onText={t('common:commonWords.onText')}
          offText={t('common:commonWords.offText')}
          onClick={toggleEnableShippingCosts}
        />
      </div>
    </div>
  );
}

export default AppSettingsConfig;
